module.exports = __webpack_public_path__ + "static/media/image11.6e34fd9e.png";